module.exports = __webpack_public_path__ + "img/IMG_9621_L.60e67452.webp";